const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export default (dateArg) => {
    const date = new Date(dateArg);
    const options = {
        weekday: "long",
        day: "numeric",
        month: "long"
    };
    return date.toLocaleString("en-IN", options);
};

export const dateFormatterWithYear = (dateArg) => {
    const date = new Date(dateArg);
    const options = {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric"
    };
    return date.toLocaleString("en-IN", options);
};

export const getDate = (dateArg) => {
    const date = new Date(dateArg);
    return `${date.getDate()}`;
};

export const getDay = (dateArg) => {
    const date = new Date(dateArg);
    return `${days[date.getDay()]}`;
};

export const getMonthDayAndYear = (dateArg) => {
    const date = new Date(dateArg);
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const day = date.getUTCDate();
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();

    return `${month} ${day}, ${year}`;
};

export const dateFormatWithMonthDateYear = (date) => {
    return new Date(date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
};
